import React from 'react'
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'
import { Link } from 'gatsby'

export default function Content2({ data }) {
    const { content2BackgroundColor, content2ButtonEmailLink, content2ButtonInternalLink, content2ButtonText, content2ButtonType,
        content2Pattern, content2Text, content2Title, content2Image, content2ColumnRatio, content2ButtonExternalLink } = data
    console.log('component: ' + content2ColumnRatio);

    const column = content2ColumnRatio == '5: 5 and 7' ? 5 : 6;

    return (
        <div className={`image-radius-pattern-2 about-b-fut-school-wrp light-${content2BackgroundColor}-bg`}>
            <div className='container'>
                <div className='row'>
                    <div className={`col-md-${column}`}>
                        <div className={`image-l-patrn-2 img-${content2Pattern}-bg hide-mobile`} >
                            <GatsbyImage
                                image={getImage(content2Image?.localFile)}
                                alt='image'
                            />
                        </div>
                    </div>
                    <div className={`col-md-${12 - column}`}>
                        <div className={`image-l-patrn-2 img-${content2Pattern}-bg hide-desk`}>
                            <GatsbyImage
                                image={getImage(content2Image?.localFile)}
                                alt='image'
                            />
                        </div>
                        <h2 className='heading-level-2 blue-color'>{content2Title && parser(content2Title)}</h2>
                        <p>{content2Text && parser(content2Text)}</p>

                        {
                            content2ButtonType == 'email' && (
                                content2ButtonEmailLink && (
                                    <a href={`mailto: ${content2ButtonEmailLink}`} className='btn blue-btn'>
                                        {content2ButtonText}
                                    </a>
                                )
                            )
                            || content2ButtonType == 'internal' && (
                                content2ButtonInternalLink && <Link to={content2ButtonInternalLink?.uri} className='btn blue-btn'>
                                    {content2ButtonText}
                                </Link>
                            ) || content2ButtonType == 'external' && (
                                content2ButtonExternalLink && (
                                    <a href={content2ButtonExternalLink} className="btn blue-btn">{content2ButtonText}</a>
                                )
                            ) || <></> // Default if none of the above conditions are true
                        }

                    </div>
                </div>
            </div>
        </div>
    )
}
